




import { Component, Vue, Prop } from 'vue-property-decorator';
import { Order } from '@/models/order';

@Component
export default class OrderStatusLabel extends Vue {
    @Prop({ required: true }) public order: Order;

    public get className(): { [key: string]: boolean } {
        switch (this.order.status) {
        case 0:
            return { 'label-warning': true };
        case 1:
            return { 'label-info': true };
        case 2:
            return { 'label-success': true };
        default:
            return { 'label-default': true };
        }
    }
    public get description(): string {
        switch (this.order.status) {
        case 0:
            return `Ordered`;
        case 1:
            return `Received`;
        case 2:
            return `Delivered`;
        default:
            return `Unknown`;
        }
    }
}
